import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormROValue from '../../../../library/form/components/FormROValue1';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormStatus from '../../../../library/form/components/FormStatus';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColThree, UiCol } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const StockCheckHeaderView = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span><FormTitle formObject={formObject} value='Header' /></span>
                </UiTitle>
                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>

                    <FormButton formObject={formObject} ksc="p" rowKey="" confirm="Are you sure"
                        starIcon={"collection"}
                        action={{ actionId: "refresh", refreshMode:"dep", actionMessage: "PleaseWait", paramName: "prepareListBtn", actionParam: {isPrepareList: 1}, containerKey: "" }}
                        className="uiActionButton" text={<SarasTrans value="Prepare Stock List" />}></FormButton>

                    <FormButton formObject={formObject} ksc="" rowKey="" confirm="Do you want to Start Stock Check?"
                        starIcon={"play"}
                        action={{ actionId: "refresh", refreshMode:"dep", actionMessage: "PleaseWait", paramName: "startStockCheckBtn", actionParam: {actionType:"startStockCheck"}, containerKey: "" }}
                        className="uiActionButtonBlue" text={<SarasTrans value="Start Stock Check" />}></FormButton>

                    <FormButton formObject={formObject} ksc="" rowKey="" confirm="Are you sure Stock Check is done?"
                        starIcon={"stop"}
                        action={{ actionId: "refresh", refreshMode:"dep", actionMessage: "PleaseWait", paramName: "finishStockCheckBtn", actionParam: {actionType:"finishStockCheck"}, containerKey: "" }}
                        className="uiActionButtonBlue" text={<SarasTrans value="Finish Stock Check" />}></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColThree>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="Document ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "location" }} value="Location" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "location" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requestDate" }} value="Request Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "requestDate" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "inchargeUser" }} value="Incharge User" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "inchargeUser" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdOn" }} value="Created On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "createdOn" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} value="Created By" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} className='uiSpacerH10' />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetDocType" }} value="Target Document" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "targetDocType" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "scopeFilters" }} value="Scope Filters" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "scopeFilters" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} value="Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="docStatus"/>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comments" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "comment" }} className='uiSpacerH10' />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <div>
                            <span className="uiBold uiHighlightBlue">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qrCode" }} value="Document QR Code" />
                            </span>
                        </div>
                        <FormAttachment imgHeight="150px" formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "qrCode" }} />
                    </UiCol>
                </UiGridColThree>
            </UiViewContent>
        </UiView>
    )
}

export default withView(StockCheckHeaderView, "stockCheckHeader", "all");